import searchbar, { en as searchbarEN, ca as searchbarCA } from './searchbar'
import list, { en as listEN, ca as listCA } from './list'

export default {
  schoolsNetwork: 'Red de escuelas',
  manageTeam: 'Administrar equipo',
  seeTeam: 'Ver equipo',
  deleteMembersModal: {
    title: '¿Estás seguro que quieres eliminar a estos integrantes?',
    message: 'Al presionar eliminar se borrarán los siguientes integrantes:',
    confirm: 'Eliminar',
    cancel: 'Cancelar'
  },
  deleteUserModal: {
    title: '¿Estás seguro que quieres eliminar a este integrante?',
    message: 'Al presionar eliminar se borrará el siguiente usuario: <span class="text-normal m-top-1 bold">{user}</span>',
    confirm: 'Eliminar',
    cancel: 'Cancelar'
  },
  editionSuccess: '¡Has editado al integrante con éxito!',
  editionError: 'Ha ocurrido un error al editar, intente nuevamente',
  deletedSuccess: '¡Has eliminado los integrantes con éxito!',
  deletedError: 'Ha ocurrido un error, por favor intenta de nuevo',
  list,
  searchbar
}

export const en = {
  schoolsNetwork: 'Schools network',
  manageTeam: 'Manage team',
  seeTeam: 'View team',
  deleteMembersModal: {
    title: 'Are you sure you want to delete these members?',
    message: 'Clicking delete will delete the following members:',
    confirm: 'Delete',
    cancel: 'Cancel'
  },
  deleteUserModal: {
    title: 'Are you sure you want to delete this member?',
    message: 'Clicking delete will delete the following user: <span class="text-normal m-top-1 bold">{user}</span>',
    confirm: 'Delete',
    cancel: 'Cancel'
  },
  editionSuccess: 'You have successfully edited the member!',
  editionError: 'An error occurred when editing the user, please try again',
  deletedSuccess: 'You have successfully deleted the members!',
  deletedError: 'An error occurred when deleting the members, please try again',
  list: listEN,
  searchbar: searchbarEN
}

export const ca = {
  schoolsNetwork: 'Xarxa d\'escoles',
  manageTeam: 'Administrar equip',
  seeTeam: 'Veure equip',
  deleteMembersModal: {
    title: 'Estàs segur que vols eliminar aquests integrants?',
    message: 'En prémer eliminar s\'esborraran els següents integrants:',
    confirm: 'Eliminar',
    cancel: 'Cancelar'
  },
  deleteUserModal: {
    title: 'Estàs segur que vols eliminar a aquest integrant?',
    message: 'En prémer eliminar s\'esborrarà el següent usuari: <span class="text-normal m-top-1 bold">{user}</span>',
    confirm: 'Eliminar',
    cancel: 'Cancelar'
  },
  editionSuccess: 'Has editat l\'integrant amb èxit!',
  editionError: 'Ha ocurrido un error al editar, intente nuevamente',
  deletedSuccess: 'Has eliminat els integrants amb èxit!',
  deletedError: 'Ha ocurrido un error, por favor intenta de nuevo',
  list: listCA,
  searchbar: searchbarCA
}
